import { Organisationseinheit } from 'fobclient/lib/entity'
import OrgaIdent from '@/schema/OrgaIdent'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('Organisationseinheit')

export default {
  label: 'Organisationseinheit',
  route: 'organisationseinheit',
  class: Organisationseinheit,
  className: 'organisationseinheit',
  tableSelectColumns: [
    {
      label: 'name',
      field: 'name'
    },
    {
      label: 'parent',
      field: 'parentOrgaName'
    },
    {
      label: 'kostenstelle',
      field: 'kostenstelle'
    }
  ],
  fields: [
    {
      label: 'Organisationseinheit.form.ueberOrganisationseinheit',
      cardinality: 'single',
      icon: 'sitemap',
      field: 'ueberOrganisationseinheit',
      type: 'object',
      // schema: 'parent',
      schema: {
        route: 'organisationseinheit',
        className: 'organisationseinheit',
        fields: [
          {
            label: 'Name',
            field: 'name'
          },
          {
            label: 'Kostenstelle',
            field: 'kostenstelle'
          }
        ]
      },
      finder: {
        name: 'bySearchRepLike',
        multiValue: false,
        minLength: 0
      },
      // true and false make different fields correct!
      nested: false
    },
    Fields.String('name'),
    Fields.Date('beginn'),
    Fields.Date('ende'),
    {
      ...Fields.Text('beschreibungDE', 6000),
      render: 'html'
    },
    {
      ...Fields.Text('beschreibungEN', 6000),
      render: 'html'
    },
    Fields.String('kostenstelle'),
    {
      label: 'Organisationseinheit.form.orgaIdent',
      field: 'orgaIdent',
      type: 'object',
      cardinality: 'many',
      onlyCreate: true,
      render: 'stringRep',
      schema: OrgaIdent
    },
    Fields.Boolean('inPubfob'),
    {
      ...Fields.Boolean('obsolet'),
      view: (data, user) => {
        return user.roles.ADMIN === true
      }
    },
    {
      label: 'Organisationseinheit.form.unterOrganisationseinheiten',
      field: 'unterOrganisationseinheiten',
      sortBy: 'kostenstelle',
      inEditView: false
    },
    {
      ...Fields.Boolean('skipValidation'),
      label: 'skipValidation',
      view: () => false,
      inEditView: true,
    },
  ]
}



// WEBPACK FOOTER //
// ./src/schema/Organisationseinheit.js